<template>
    <div>
        <my-form 
        label-width="0" 
        v-model="form" 
        @submit="submit()">

            <el-form-item 
            :rules="newRule('登录名/手机号', 'required','mobeil')" 
            prop="name">
                <el-input 
                    v-model="form.name" 
                    clearable 
                    autocomplete="off" 
                    placeholder="请输入登录名/手机号">
                </el-input>
            </el-form-item>

            <el-form-item 
                :rules="newRule('登录密码', 'required')" 
                prop="password">
                <el-input 
                    v-model="form.password" 
                    clearable 
                    type="password" 
                    autocomplete="off" 
                    placeholder="请输入密码">
                </el-input>
            </el-form-item>

            <el-form-item 
                :rules="newRule('验证码', 'required')" 
                class="yzmInput"
                prop="captcha" 
                v-if="yzmshow">

                <el-input 
                    v-model="form.captcha" 
                    clearable 
                    autocomplete="off" 
                    placeholder="请输入验证码">
                </el-input>

                <img 
                    id="captcha" 
                    style="cursor: pointer; cursor: hand; float:right; width: 140px; height:35px;"
                    onclick="this.src='/hzbtenderagentzero/admin/captcha.html?'+Math.random();" 
                    src="/hzbtenderagentzero/admin/captcha.html"
                >
            </el-form-item>

            <el-form-item>
                <a 
                    @click="losenameHandler()">
                    忘记登录名
                </a>
                &nbsp;|&nbsp;
                <a 
                    @click="losePwdHandler()">
                    忘记密码
                </a>
                &nbsp;|&nbsp;
                <a 
                    @click="tixing()" 
                    style="cursor:pointer;">
                    手机号不再使用
                </a>
            </el-form-item>

            <template 
            slot="btn" 
            slot-scope="scope">
                <el-button 
                    @click="scope.submitHandler" 
                    @keyup.enter.native="loginEnter()" 
                    type="primary" 
                    style="width:100%;height:45px;font-size:16px">
                        登&nbsp;&nbsp;录
                </el-button>
                <p style="text-align:center;">
                    若您尚未注册，请点击
                    <a :href="zhuce" target="_blank" style="color:#008eff">注册</a>
                </p>
            </template>
        </my-form>
    </div>
</template>

<script>
export default {
    props: {
        roleCode: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        // 登录参数
        form:{
            captcha:''
        },
        yzmshow:false,
        captchaurl:'',

        zhuce:window._config.zhuce,
    }),
    created() {
        var _self = this;
        document.onkeydown = function (e) {
            if (window.event == undefined) {
                var key = e.keyCode;
            } else {
                var key = window.event.keyCode;
            }
            if (key == 13) {
                _self.loginEnter();
            }
        }
        
        
    },
    beforeDestroy(){
        // 注销回车事件
        document.onkeydown = null
    },
    methods: {
        // 登录
        submit(){
            
            var that = this;
            that.form.userType = that.roleCode;
            if (that.form.name == '' || that.form.name == undefined) {
                ShowMsg('请输入账号', 'error')
            } else if (that.form.password == '' || that.form.password == undefined) {
                ShowMsg('请输入密码', 'error')
            } else {
                $.post(`${that.$store.getters.ageUrl}/admin/login.json`,that.form, function (data, res) {
                    if(data.result){
                        that.$store.dispatch('views/login', {
                            obj:that.form
                        });
                    }else{
                        that.yzmshow = true;
                        ShowMsg(data.errors.captcha,'error');
                    }
                    
                })
            }
        },
        // 回车登录
        loginEnter(){
            this.submit()
        },
        // 忘记登录名
        losenameHandler(){
            this.$emit('losename')
        },
        // 忘记密码
        losePwdHandler(){
            this.$emit('losePwd')
        },
        // 提醒
        tixing(){
            this.$emit('tixing')
        }
    },
    mounted() {
        var that = this;
        
        // that.captchaurl = '/purchaser/captcha.htm?' + Math.random();
    },
}
</script>

<style scoped lang="scss">
    .yzmInput{ position: relative; }
    .yzmInput img{ position: absolute; z-index: 100; top: 4px; right:5px }
</style>